import styled from "styled-components";

export const Header = styled.h2`
  text-align: center;
  font-size: 25px;
  margin-bottom: 5px;
`;
